import {Detail, Reserve,refreshReservesInstruction} from "@/api/models";
import {PublicKey, TransactionInstruction} from "@solana/web3.js";
import {getBridgePool, getBridgeProgram} from "@/api/context/bridgePool";
const MAX_RESERVE_LENGTH = 3
export const refreshReserves = async (
    instructions: TransactionInstruction[],
    reserves:Array<Detail<Reserve>>,
    lendingProgramId:PublicKey
)=>{
    if (reserves.length>MAX_RESERVE_LENGTH){
        const startReserves = reserves.slice(0,MAX_RESERVE_LENGTH)
        await refreshBridgePool(instructions,startReserves)
        instructions.push(refreshReservesInstruction(
            startReserves,
            lendingProgramId
        ))
        const endReserves = reserves.slice(MAX_RESERVE_LENGTH,reserves.length)
       await refreshReserves(instructions,endReserves,lendingProgramId )
    } else {
        await refreshBridgePool(instructions,reserves)
        instructions.push(refreshReservesInstruction(
            reserves,
            lendingProgramId
        ))
    }
}
async function refreshBridgePool(instructions:TransactionInstruction[],reserves:Array<Detail<Reserve>>){

    const bridgePoolProgram = await getBridgeProgram()
    for (const reserve of reserves){
        console.log("reserve.info.isLP",reserve.info.isLP)
        if (reserve.info.isLP){
            const bridgePoolID = reserve.info.liquidity.params_1
            const bridgePool = await getBridgePool(bridgePoolID)

            instructions.push(bridgePoolProgram.instruction.refresh(
                {
                    accounts:{
                        pool: bridgePoolID,
                        lpPrice: bridgePool.lpPriceAccount,
                        ammId: bridgePool.ammId,
                        lpMint: bridgePool.lpMint,
                        lpSupply: bridgePool.lpSupply,
                        coinMintPrice: bridgePool.coinMintPrice,
                        pcMintPrice:bridgePool.pcMintPrice,
                        ammOpenOrders:bridgePool.ammOpenOrders,
                        coinMintSupply:bridgePool.ammCoinMintSupply,
                        pcMintSupply:bridgePool.ammPcMintSupply,
                        farmLedger:bridgePool.farmLedger,

                    }
                }
            ))
        }
    }
}